import { Observable } from 'rxjs';
import { BaseController } from '~client/controller/base-controller';
import { EventStreamInfoResponse } from '~client/model/event-stream-info-response';
import { ResponseEntity } from '~client/model/response-entity';

export class EventStreamClientController extends BaseController {
  /** Returns the streaming info for an event. */
  public getStreamingEventInfo$(eventId: string): Observable<EventStreamInfoResponse> {
    return this.get$('/client/streaming/event/info', { eventId });
  }

  /**
   * Ends the live stream by stopping the media live channel if it is running, setting the
   * liveStreamEndDate (defaults to now) and changing the event end date to be
   * liveStreamEndDate + event streamReplaySeconds. If the end time is in the future, this will
   * schedule a job to run at that time instead of executing immediately.
   * @param eventId
   * @param shouldScheduleInfraDestruction
   * @param shouldHarvest
   */
  public endLiveStream$(
    eventId: string,
    shouldScheduleInfraDestruction: boolean,
    shouldHarvest: boolean,
  ): Observable<ResponseEntity> {
    return this.post$('/client/streaming/event/end-live-stream', {
      eventId,
      shouldHarvest,
      shouldScheduleInfraDestruction,
    });
  }

  /** Starts the next segment of the event stream. */
  public startNextSegment$(eventId: string): Observable<ResponseEntity> {
    return this.post$('/client/streaming/event/start-next-segment', { eventId });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/client/src/controller/event-stream-client-controller.ts